import axiosInstance from './axios-instance';

export const getPdfFileNameFromLambdaResponse = (response: { pdfName?: string } = {}) => {
  const pdfName = response?.pdfName || '';
  if (!pdfName) {
    throw new Error('Missing pdfName in create-pdf response');
  }

  const segments = pdfName.split('/').filter(Boolean);
  return segments[segments.length - 1] || pdfName;
};

export const callLambda = async (
  payload: any,
  accountId: number,
  fileStoreUrl: string,
  workOrder: any
) => {
  try {
    const response = await axiosInstance.post(
      `/workOrder/create-pdf`,
      JSON.stringify({
        data: payload,
        accountId,
        fileStoreUrl,
        workOrder,
      })
    );

    return response.data;
  } catch (error) {
    console.error('Error with call lambda: ', error);
    throw error;
  }
};
